// ** Initial State
const initialState = {
  allData: [],
  data: [],
  allLevels: [],
  levels: [],
  allSublevels: [],
  sublevels: [],
  allSubjects: [],
  subjects: [],
  total: 1,
  params: {},
  selectedLevel: null,
  selectedSublevel: null,
  selectedSubject: null,
};

const education = (state = initialState, action) => {
  switch (action.type) {
    case "EMPTY_REDUCER":
      return initialState;
    case "GET_ALL_LEVELS":
      return { ...state, allLevels: action.data };
    case "GET_LEVELS":
      return {
        ...state,
        levels: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case "GET_ALLSUBLEVELS":
      return { ...state, allSublevels: action.data };
    case "GET_SUBLEVELS":
      return {
        ...state,
        sublevels: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case "GET_ALLSUBJECTS":
      return { ...state, allSubjects: action.data };
    case "GET_SUBJECTS":
      return {
        ...state,
        subjects: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case "ADD_SUBJECT":
      return { ...state };
    case "ADD_LEVEL":
      return { ...state };
    case "ADD_SUBLEVEL":
      return { ...state };
    case "DELETE":
      return { ...state };

    case "GET_LEVEL":
      return { ...state, selectedLevel: action.selectedLevel };
    case "UPDATE_LEVEL":
      return { ...state };
    case "GET_SUBLEVEL":
      return { ...state, selectedSublevel: action.selectedSublevel };
    case "UPDATE_SUBLEVEL":
      return { ...state };
    case "GET_SUBJECT":
      return { ...state, selectedSubject: action.selectedSubject };
    case "UPDATE_SUBJECT":
      return { ...state };

    case "GET_ALL_DATA":
      return { ...state, allData: action.data };
    case "GET_DATA":
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
      };
    // case "GET_USER":
    //   return { ...state, selectedUser: action.selectedUser };
    case "ADD_USER":
      return { ...state };
    case "DELETE_USER":
      return { ...state };
    case "UPDATE_USER":
      return { ...state };
    default:
      return { ...state };
  }
};
export default education;
